module.exports = __webpack_public_path__ + "img/zimmer-frei-7.91129c74.jpg";